import httpClientFactory from "./http-client.factory";
import AuthService from "./auth.service";
import CrmService from "./crm.service";



export const httpClient = httpClientFactory();

export const authService = new AuthService(httpClient);
export const crmService = new CrmService(httpClient);


